import Vue from 'vue';
import OwlCarousel from 'v-owl-carousel'
import InputSearchProjects from '../../js/components/index/InputSearchProjects.vue'

Vue.component('carousel', OwlCarousel);

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (document.getElementById("section-banner-home")) {
    new Vue({
        el: '#section-banner-home',
        components: {
            InputSearchProjects,
        },
    });
}